import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { unauthenticateUser } from '../actions/index';

class Logout extends Component {
  componentDidMount() {
    this.props.unauthenticateUser();
    this.props.history.goBack();
  }

  render() {
    return (
      <div>
        <p>
          <FormattedMessage
            id="logout.message"
            defaultMessage="Logging you out... if you are not redirected in 3 seconds, {link}."
            values={{
              link: (
                <a href="/">
                  <FormattedMessage
                    id="logout.clickHere"
                    defaultMessage="click here"
                  />
                </a>
              )
            }}
          />
        </p>
      </div>
    );
  }
}

export default connect(null, { unauthenticateUser })(Logout);



// WEBPACK FOOTER //
// ./src/desktop/components/logout.js